import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { ListItem, Stack, Typography, IconButton, Box } from '@mui/material'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'

import PatientIcon from '@/components/ui/icons/Patient'
import { PatientQueueEntry } from '@/core/models/patient-queue.model'

import { useRemoveQueuedPatient } from '../model/useRemoveQueuedPatient'
import ConsultationIcon from '@/components/ui/icons/Consultation'
import { useState } from 'react'
import { PreConsultationModal } from './PreConsultationModal'

export function SortablePatientItem({ patientQueueEntry: { patient } }: { patientQueueEntry: PatientQueueEntry }) {
  const { attributes, listeners, setActivatorNodeRef, setNodeRef, transform, transition, isDragging } = useSortable({ id: patient._id })

  const style: React.CSSProperties = {
    position: 'relative',
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div ref={setNodeRef} style={style}>
      <ListItem disableGutters>
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center" sx={{ width: '100%' }}>
          <IconButton aria-label="drag" ref={setActivatorNodeRef} {...attributes} {...listeners}>
            <DragIndicatorIcon />
          </IconButton>
          <Stack direction="row" spacing={1} alignItems="center" flex={1}>
            <PatientIcon fontSize="small" />
            <Typography variant="body2" fontWeight="medium">
              {patient.userInfo.name} {patient.userInfo.surname}
            </Typography>
          </Stack>
          <PreConsultationButton patientId={patient._id} />
          <DeleteQueuedPatientButton patientId={patient._id} />
        </Stack>
      </ListItem>
    </div>
  )
}

function DeleteQueuedPatientButton({ patientId }: { patientId: string }) {
  const [removeQueuedPatient, isRemoving] = useRemoveQueuedPatient()

  return (
    <IconButton color="error" onClick={() => removeQueuedPatient(patientId)}>
      <DeleteForeverIcon />
    </IconButton>
  )
}

function PreConsultationButton({ patientId }: { patientId: string }) {
  const [openPreConsultationModal, setOpenPreConsultationModal] = useState(false)
  return (
    <>
      <IconButton color="primary" onClick={() => setOpenPreConsultationModal(true)}>
        <ConsultationIcon />
      </IconButton>
      <PreConsultationModal
        open={openPreConsultationModal}
        onClose={() => setOpenPreConsultationModal(false)}
        patientId={patientId}
        onSelect={() => {
          setOpenPreConsultationModal(false)
        }}
      />
    </>
  )
}
